import cx from 'classnames';

import { ChevronIcon } from 'src/components/ChevronIcon';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { hasImageOverlayTexts } from 'src/data/image';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { ImageOverlayTextValue } from '../ImageOverlayTextValue';

import { useStyles } from './useStyles';

const PLACEHOLDER = 'Add Headline, Sub-headline & Call to action';

export const ImageOverlayTextControl = ({
  className,
  imageOverlayProperties,
  onClick,
  active,
  disabled,
}) => {
  const styles = useStyles();

  const isEmpty = !hasImageOverlayTexts(imageOverlayProperties);

  return (
    <CustomButtonBase
      className={cx(styles.root, className, {
        [styles.active]: active,
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      {isEmpty ? (
        <CustomTypography
          className={styles.text}
          variant={TYPOGRAPHY_VARIANT.regular14}
        >
          {PLACEHOLDER}
        </CustomTypography>
      ) : (
        <ImageOverlayTextValue
          className={styles.overlayValue}
          imageOverlayProperties={imageOverlayProperties}
        />
      )}

      <ChevronIcon
        className={styles.icon}
        direction={active ? ROTATE_DIRECTION.right : ROTATE_DIRECTION.down}
      />
    </CustomButtonBase>
  );
};
